export default "__VITE_ASSET__D_FImz6B__"